import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { IRadioGroup } from '@nibtravel/shared/ui/forms/radio-group';
import { Qqc } from '@nibtravel/shared/util/e2e';
import { IPolicyHolderAgeConfig } from '@nibtravel/shared/util/models';
import { filter, map } from 'rxjs/operators';

import { TravellerAgeSelector } from './age-input.selector';

@Injectable({ providedIn: 'root' })
export class AgeRadioService {
  constructor(private store: Store) {}

  getAgeRadioConfig() {
    return this.store.select(TravellerAgeSelector.policyHolderConfig).pipe(
      filter((config) => !!config),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((config) => this.createRadioConfig(config!))
    );
  }

  private createRadioConfig(config: IPolicyHolderAgeConfig) {
    const radioConfig = {
      hostId: 'travellers',
      label: 'Number of travellers',
      groupName: 'policyHolders',
      data: [
        {
          inputId: 'radio-id-1',
          name: '1',
          label: '1',
          labelId: 'radio-label-id-1',
          value: 1,
          checked: true,
          e2eId: Qqc.OneTraveller,
        },
        {
          inputId: 'radio-id-2',
          name: '2',
          label: '2',
          labelId: 'radio-label-id-2',
          value: 2,
          e2eId: Qqc.TwoTravellers,
        },
        {
          inputId: 'radio-id-family',
          name: 'family',
          label: 'Family',
          labelId: 'radio-label-id-family',
          value: config.maxDependents + config.maxTravellers,
          e2eId: Qqc.FamilyTravellers,
        },
      ],
    };

    return this.fromInitialState(radioConfig);
  }

  private fromInitialState(radioConfig: IRadioGroup): IRadioGroup {
    let initialState = this.store.selectSnapshot(
      TravellerAgeSelector.travellerSelection
    );
    // if users come from the horizontal qqc, then the states are already populated with the values from the url
    const inputState = this.store.selectSnapshot((v) => v).quote.input;
    if (inputState?.policyHolders) {
      const policyHolders = inputState.policyHolders;
      switch (policyHolders.length) {
        case 1:
          initialState = 'radio-id-1';
          break;
        case 2:
          initialState = 'radio-id-2';
          break;
        default:
          initialState = 'radio-id-family';
      }
    }

    if (initialState != '') {
      radioConfig.data.forEach(
        (item) => (item.checked = item.inputId === initialState)
      );
    }

    return radioConfig;
  }
}
